module.exports = __webpack_public_path__ + "assets/icons/ic_visibility_off_24px.svg";